import { Paper } from "@mui/material";
import { FC, useEffect, useState } from "react"
import { Listagem } from "src/components/projetos/Listagem";
import { RevisaoProjeto } from "src/components/projetos/RevisaoProjeto";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import { STATUS_CODE } from "src/framework/providers/api";
import { pageTitle$ } from "src/framework/store/ApiEvents";
import { notifierStore } from "src/framework/store/NotifierStore";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { limitacoes$ } from "src/store/global.store";

const projetosProvider = new ProjetosProvider();
const ProjetosPage: FC = () => {
    pageTitle$.next("Plataforma Solar");

    const [editRow, setEditRow] = useState<any>(null);
    const [doSearch, setDoSearch] = useState<boolean>(false);
    const [currentTab, setCurrentTab] = useState<string>("list");
    const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null);

    const handleChangeTabManutencao = (newTab: any) => {
        setCurrentTab(newTab)
    }

    const init = async (): Promise<void> => {
        const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
        setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)
    }

    useEffect(() => {
        init()
    }, []);

    return <>
        <Paper elevation={0}>
            <TabControl
                currentTabName={currentTab}
                onChangeTab={(handleChangeTabManutencao)}
            >
                <TabContent name={"list"} label={"Listagem"} visible={true}>
                    <div className="X12" id="grid" hidden={currentTab !== "list"}>
                        <Listagem onEdit={(row) => {

                            const indexLimitacao = limitacoes$.getValue().data.findIndex((l) => {
                                return row.solicitacao.limitacao_projeto_id === l.id
                            })

                            if (indexLimitacao > -1) {
                                row.limitacao_projeto = limitacoes$.getValue().data[indexLimitacao];
                            }

                            setEditRow(row)
                            setCurrentTab("revisao")
                        }}
                            distribuidorRevendaUsuario={distribuidorRevendaUsuario}
                            doSearch={doSearch}
                            cancelSearch={() => setDoSearch(false)}
                        />
                    </div>
                </TabContent>

                <TabContent name={"revisao"} label={`Revisão ${editRow?.codigo_venda}`} visible={editRow !== null}>
                    <div className="X12" hidden={currentTab !== "revisao"}>
                        {currentTab === "revisao" && (
                            <RevisaoProjeto projeto={editRow}
                                onExit={() => {
                                    setEditRow(null)
                                    setCurrentTab("list")
                                    setDoSearch(true);
                                }}
                                onSave={(projeto) => {
                                    projetosProvider.saveRevisaoProjeto(projeto).then((response) => {
                                        if (response.statusCode === STATUS_CODE.OK) {
                                            notifierStore.setNotifier({
                                                title: "Aviso!",
                                                content: "Revisão salva com sucesso!",
                                                timeOut: 3000,
                                                onClose: () => {
                                                    notifierStore.setOpen(false);
                                                }
                                            })
                                            notifierStore.setOpen(true);

                                            setEditRow(null);
                                            setCurrentTab("list");
                                            setDoSearch(true);
                                            return;
                                        }

                                        if (Array.isArray(response?.message)) {
                                            notifierStore.setNotifier({
                                                title: "Aviso!",
                                                content: response.message,
                                                timeOut: 3000,
                                                onClose: () => {
                                                    notifierStore.setOpen(false);
                                                }
                                            })
                                            notifierStore.setOpen(true);
                                        }
                                    })
                                }}
                            />
                        )}
                    </div>
                </TabContent>
            </TabControl>
        </Paper>
    </>
}

export { ProjetosPage }